import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-media-container',
  templateUrl: './media-container.component.html',
  styleUrls: ['./media-container.component.less'],
})
export class MediaContainerComponent implements OnInit {
  @Output() fileUploaded: EventEmitter<string> = new EventEmitter();
  cameraActive = false;
  signatureActive = false;

  @Input() isImage = false;
  @Input() allowUploadFile = true;
  @Input() allowSignature = true;
  @Input() allowUsingCamera = true;
  //@Input() name = ''

  constructor() {}

  ngOnInit(): void {
    if (!this.allowUploadFile && this.allowUsingCamera) {
      this.cameraActive = true;
    } else if (!this.allowUploadFile && this.allowSignature) {
      this.signatureActive = true;
    }
  }
}
